export default __webpack_public_path__ + "static/media/down.bec0ced8.mp3";